// extracted by mini-css-extract-plugin
export default {"hideTooltip":"a9-z","fadeIn":"b9-z","delay":"c9-z","recommendedSizeTooltip":"d9-z"};